module.exports = __webpack_public_path__ + "img/zurich-sigorta.c85dafde.jpg";